import { render } from "./Claim_1_submittedBillList.vue?vue&type=template&id=47b3931c&scoped=true&ts=true"
import script from "./Claim_1_submittedBillList.vue?vue&type=script&lang=ts"
export * from "./Claim_1_submittedBillList.vue?vue&type=script&lang=ts"

import "./Claim_1_submittedBillList.vue?vue&type=style&index=0&id=47b3931c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b3931c"]])

export default __exports__